import { render } from "./TyrePatterns.html?vue&type=template&id=51324dfe&scoped=true&ts=true&external"
import script from "./TyrePatterns.ts?vue&type=script&lang=ts&external"
export * from "./TyrePatterns.ts?vue&type=script&lang=ts&external"

import "./TyrePatterns.scss?vue&type=style&index=0&id=51324dfe&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51324dfe"]])

export default __exports__